import React from "react";
import MarketingPage from "./MarketingPage";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const plans = [
  { name:"Starter", price:"A$29", cadence:"/mo", desc:"Small teams getting started.", features:["1 workspace","Up to 3 users","50 generations / month","Template uploads","Word export","Document library"], cta:"Start free", to:"/signup" },
  { name:"Professional", price:"A$99", cadence:"/mo", desc:"Regular business use.", features:["1 workspace","Up to 15 users","500 generations / month","Multiple templates","Workspace standards","Version history","Priority support"], highlight:true, cta:"Start free", to:"/signup" },
  { name:"Business", price:"A$299", cadence:"/mo", desc:"Larger teams and higher volume.", features:["Up to 3 workspaces","Up to 50 users","Advanced permissions","Higher limits","Centralised standards","Custom onboarding"], cta:"Start free", to:"/signup" },
  { name:"Enterprise", price:"Talk to us", cadence:"", desc:"Custom agreements and integrations.", features:["Custom agreements","SSO","Integrations","Security review","Dedicated support","Enterprise onboarding"], cta:"Contact sales", to:"/contact" },
];

export default function Pricing() {
  return (
    <MarketingPage eyebrow="Pricing" title="Simple pricing that scales with your team." subtitle="All prices in Australian dollars (AUD). Every plan includes editable Word export, workspace standards and version history. Cancel anytime.">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {plans.map((p) => (
          <div key={p.name} className={`fx-panel p-6 flex flex-col ${p.highlight ? "border-cyan-400/40 fx-glow-cyan" : ""}`} data-testid={`pricing-card-${p.name.toLowerCase()}`}>
            {p.highlight && <div className="mono text-[10px] uppercase tracking-widest text-cyan-300 mb-2">Most popular</div>}
            <div className="font-display font-semibold text-lg text-slate-100">{p.name}</div>
            <div className="mt-2 text-3xl font-display font-extrabold text-white">{p.price}<span className="text-sm text-slate-500 font-normal ml-1">{p.cadence}</span></div>
            <div className="mt-1 text-sm text-slate-400 min-h-[40px]">{p.desc}</div>
            <ul className="mt-5 space-y-2 flex-1">
              {p.features.map((f) => (
                <li key={f} className="text-sm text-slate-300 flex gap-2"><Check size={14} className="text-cyan-400 mt-0.5"/>{f}</li>
              ))}
            </ul>
            <Link to={p.to} data-testid={`pricing-${p.name.toLowerCase()}`} className={`mt-6 block text-center px-4 py-2.5 rounded-lg font-medium ${p.highlight ? "fx-btn-primary text-white" : "border border-white/10 hover:border-white/20 text-slate-200"}`}>{p.cta}</Link>
          </div>
        ))}
      </div>
    </MarketingPage>
  );
}
